import { PartTree } from "./PartTree"
import Search from "./Search"
import CacheKeyData from "./CacheKeyData"
import '../../assets/styles.css';

export function CacheLayout() {
    return (
        <div className="flex flex-row h-screen">
            <aside className="flex flex-col border-r border-gray-300 h-screen overflow-hidden w-75">
                <Search />
                <PartTree />
            </aside>
            <CacheKeyData />
        </div>
        
    )
}